export enum SPORTTAB {
  Normal = 1,
  Advanced = 2,
  Master = 3,
}

/** 射门路径：LeftIn/RightIn 进球，LeftOut/RightOut 未进 */
export enum PathKey {
  LeftIn = 'leftin',
  RightIn = 'rightin',
  LeftOut = 'leftout',
  RightOut = 'rightout',
}

export enum RoundStatus {
  Bet = 0,
  Drawing = 1,
  Result = 2,
}

export enum WinType {
  Normal = 1,
  Big = 2,
}

export enum RankTypeEnum {
  Daily = 1,
  Week = 2,
  Month = 3,
}

/** 重复下注可用状态：
 * 1-可以重复下注
 * 2-用户上一轮无下注
 * 3-用户本轮已使用重复下注
 * 4-重复下注将超过最大下注额
 * 5-用户余额不足
 * 6-重复下注将超过最大下注数量
 */
export enum RepeatFlag {
  CanRepeat = 1,
  NoPrevBet = 2,
  UsedThisRound = 3,
  ExceedMaxAmount = 4,
  InsufficientBalance = 5,
  ExceedMaxCount = 6,
}

export enum RESULTSTATUS {
  nopart = 0,
  success = 1,
  fail = 2,
}
